import React, { useState, useEffect } from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";
import { getTransactionEnquiry } from "../campaigns/services";
import { getDate } from "../../../utils/helper";
import { Link, useLocation, useParams } from "react-router-dom";
import { decrypt } from "../../../utils/encodingdecoding";

const renderNestedValue = (value, keyName) => {
  if (Array.isArray(value)) {
    if (value.length === 0) return <span>-</span>;
    return (
      <div className="nested-array w-100">
        {value.map((item, index) => (
          <div
            key={index}
            className={`pb-2 mb-2 ${index < value.length - 1 ? "border-bottom" : ""}`}
          >
            {renderNestedValue(item, `${keyName}-${index}`)}
          </div>
        ))}
      </div>
    );
  }

  if (value && typeof value === "object") {
    return (
      <div className="nested-object">
        {Object.entries(value).map(([subKey, subValue]) => {
          const isImage =
            typeof subValue === "string" &&
            subValue.match(/\.(jpeg|jpg|png|gif|webp)$/i);
          const isNested = subValue && typeof subValue === "object";

          return (
            <div
              key={subKey}
              className={`nested-row d-flex gap-2 mb-2 ${isNested ? "align-items-start" : "align-items-center"}`}
            >
              <strong className="flex-shrink-0" style={{ minWidth: "140px" }}>
                {subKey}:
              </strong>

              {isImage ? (
                <img
                  src={subValue}
                  alt={subKey}
                  width={80}
                  height={80}
                  className="rounded-3 border shadow-sm"
                  style={{ objectFit: "cover", cursor: "pointer" }}
                  onClick={() => window.open(subValue, "_blank")}
                />
              ) : isNested ? (
                renderNestedValue(subValue, subKey)
              ) : typeof subValue === "string" &&
                subValue.includes("https://") ? (
                <Link to={subValue} target="_blank">
                  View
                </Link>
              ) : (
                <span>
                  {subValue === null || subValue === undefined
                    ? "-"
                    : String(subValue)}
                </span>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <span>{value === null || value === undefined ? "-" : String(value)}</span>
  );
};

const TransactionViewModal = (props) => {
  const location = useLocation();
  const { id } = useParams();
  const [formData, setFormData] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token_gen"));

    if (props.show) {
      setLoader(true);
      const response = getTransactionEnquiry(
        token?.access_token,
        props.transactionId,
      );

      response
        .then((res) => {
          setFormData(res.data || {});
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
        });
    } else setLoader(false);
  }, [props.show, props.transactionId]);

  return (
    <>
      <Modal show={props.show} onHide={props.close} size="lg" centered>
        <Modal.Header>
          <Modal.Title className="fs-6 fw-semibold">
            Transaction View
          </Modal.Title>
          <CloseButton onClick={props.close} variant="black" />
        </Modal.Header>
        <Modal.Body
          className="dashboard__transactionsModal position-relative"
          style={{ minHeight: "85px" }}
        >
          {loader ? (
            <div className="mainPreloaderMain position-absolute">
              <div className="mainPreloader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : formData?.transactionId ? (
            <div className="dashboard__transactionsModalProfile">
              <div className="dashboard__transactionsModalDetails">
                <div className="dashboard__transactionsModalBottom">
                  <ul>
                    <li>
                      <span>Transaction Id:</span>{" "}
                      <span
                        className="characterLimitProperty"
                        title={formData?.transactionId}
                      >
                        {formData?.transactionId}
                      </span>
                    </li>

                    <li>
                      <span>Customer Code:</span>
                      {location?.pathname.includes("customer-view") ? (
                        <span
                          className="characterLimitProperty"
                          title={formData?.transactionId}
                        >
                          {id}
                        </span>
                      ) : (
                        <Link
                          to={`/customer-view/${formData?.customer?.customercode}?source=${location.pathname.includes("transaction") ? "trans" : "wallet"}`}
                          state={{ from: location?.state?.from }}
                        >
                          {formData?.customer?.customercode}
                        </Link>
                      )}
                    </li>

                    {formData?.transactionDetail?.transactionType ===
                      "redeem" && (
                      <>
                        <li>
                          <span>Redemption Date:</span>{" "}
                          {getDate(
                            formData?.transactionDetail?.transactionDate,
                            "MM-DD-YYYY",
                          ) !== "Invalid date"
                            ? getDate(
                                formData?.transactionDetail?.transactionDate,
                                "MM-DD-YYYY",
                              )
                            : ""}
                        </li>
                        <li>
                          <span>Redemption Points:</span>{" "}
                          {formData?.transactionDetail?.values
                            ? formData.transactionDetail.values
                            : formData?.transactionDetail?.amount}
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
              {decrypt(localStorage.getItem("Id")) === "MER000174" ? (
                <></>
              ) : (
                <div>
                  {formData?.transactionDetail?.transactionType === "refund"
                    ? ""
                    : formData.transactionDetail.transactionType !==
                        "redeem" && (
                        <div>
                          <div class="newStyleBlock_top">
                            <h2>Qualified Details</h2>
                          </div>
                          <div className="newStyleBlock">
                            <ul className="newStyleList">
                              <div className="dataLoop">
                                <div>
                                  {/* <div className={formData?.campaigns?.length > 0 ? "dataLoop__row__scroll" : ""}> */}
                                  {Array.isArray(formData?.campaigns) &&
                                  formData?.campaigns?.length > 0 ? (
                                    formData?.campaigns
                                      .filter(
                                        (ele) => ele.walletFor === "Customer",
                                      )
                                      .map((val, i) => (
                                        <div
                                          className="dataLoop__row"
                                          key={val.campaignId || i}
                                        >
                                          <div className="dataLoop__row__left">
                                            {val?.type?.toUpperCase() ===
                                              "POINT" ||
                                            val?.type?.toUpperCase() ===
                                              "VOUCHER" ? (
                                              <>
                                                <p>Campaign Code:</p>
                                                <p>Earned Type:</p>
                                                <p>Earned Value:</p>
                                              </>
                                            ) : (
                                              <p>
                                                Deducted Points {val?.value}:
                                              </p>
                                            )}
                                          </div>

                                          <div className="dataLoop__row__right">
                                            {val?.type?.toUpperCase() ===
                                              "POINT" ||
                                            val?.type?.toUpperCase() ===
                                              "VOUCHER" ? (
                                              <>
                                                <p>{val?.campaignId}</p>
                                                <p>{val?.type}</p>
                                                <p>{val?.value}</p>
                                              </>
                                            ) : (
                                              <p>{val?.value}</p>
                                            )}
                                          </div>
                                        </div>
                                      ))
                                  ) : (
                                    <>Campaign Not qualified</>
                                  )}
                                </div>
                              </div>
                            </ul>
                          </div>
                        </div>
                      )}
                  <div className="newStyleBlock_top">
                    <h2>Transaction Detail</h2>
                  </div>
                  <div className="newStyleBlock">
                    <h4>Transaction Request</h4>
                    <ul className="newStyleList__scroll">
                      <div>
                        {formData?.transactionDetail &&
                        typeof formData?.transactionDetail === "object" ? (
                          <div className="dataLoop">
                            {Object.entries(formData.transactionDetail)
                              .filter(([key]) => key.toLowerCase() !== "others")
                              .map(([key, value]) =>
                                key !== "data" &&
                                key !== "items" &&
                                key !== "schemacode" ? (
                                  <div className="dataLoop__row" key={key}>
                                    <div className="dataLoop__row__left">
                                      <p>{key}:</p>
                                    </div>

                                    <div className="dataLoop__row__right">
                                      {typeof value === "string" &&
                                      value.includes("https://") ? (
                                        <Link to={value} target="_blank">
                                          Click here
                                        </Link>
                                      ) : value && typeof value === "object" ? (
                                        renderNestedValue(value, key)
                                      ) : (
                                        <p>
                                          {Array.isArray(formData?.campaigns) &&
                                          formData?.campaigns[0]?.walletFor ===
                                            "Merchant" &&
                                          key === "transactionType"
                                            ? "Reversal"
                                            : key === "transactionDate"
                                              ? getDate(value, "DD-MMM-YYYY")
                                              : String(value)}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                ) : null,
                              )}
                            {/* Display data array fields */}
                            {formData?.transactionDetail?.data &&
                              Array.isArray(
                                formData?.transactionDetail?.data,
                              ) &&
                              formData?.transactionDetail?.data?.map(
                                (dataItem, index) => (
                                  <div className="dataLoop__row" key={index}>
                                    <div className="dataLoop__row__left">
                                      <p>Merchant Name:</p>
                                      <p>Receipt Transaction Date:</p>
                                      <p>Items:</p>
                                    </div>
                                    <div className="dataLoop__row__right">
                                      <p>{dataItem?.merchantName}</p>
                                      <p>
                                        {getDate(
                                          dataItem?.transactiondate,
                                          "DD-MMM-YYYY",
                                        )}
                                      </p>
                                      {dataItem?.items &&
                                      Array.isArray(dataItem?.items) &&
                                      dataItem?.items?.length > 0 ? (
                                        <>
                                          <>
                                            {dataItem?.items.map(
                                              (item, itemIndex) => (
                                                <p key={itemIndex}>
                                                  {Object.values(item).join(
                                                    " - ",
                                                  )}
                                                </p>
                                              ),
                                            )}
                                          </>
                                        </>
                                      ) : (
                                        <p>No items available</p>
                                      )}
                                    </div>
                                  </div>
                                ),
                              )}
                          </div>
                        ) : (
                          <p>No transaction details available</p>
                        )}
                      </div>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center mt-5">No Data Found</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.close}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TransactionViewModal;
